import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Loading from "../../../common/Loading";
import {
    getCompanyMinigameLevelSetting,
    saveCompanyMinigameLevelSetting
} from "../../../../api/api";

const DhPowerBallLevelSetting = (props) => {
    const {user} = useSelector((props) => props.account);
    const [loading, setLoading] = useState(false)
    const [searchForm, setSearchForm] = useState({
        minigameType: "dhpowerball",
        userLevel: 1
    })
    const [dataList, setDataList] = useState([])

    useEffect(() => {
        search()
    }, [searchForm.userLevel])

    const handleWhere = (e) => {
        const {name, value} = e.target;
        setSearchForm({
            ...searchForm,
            [name]: value
        })
    }

    const search = () => {
        const params = {
            companyCode: user.companyCode,
            minigameType: searchForm.minigameType,
            userLevel: searchForm.userLevel
        }

        setLoading(true)
        getCompanyMinigameLevelSetting(params).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                setDataList(data)
            }
        })
            .catch(ex => {})
            .finally(() => setLoading(false))
    }

    const save = () => {
        if (!window.confirm("저장하시겠어요?")) return;

        setLoading(true)
        saveCompanyMinigameLevelSetting(dataList).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                window.alert(data)
                search()
            }
        })
            .catch(ex => {
                window.alert(ex.response.data)
            })
            .finally(() => setLoading(false))
    }

    return (
        <div className="flex flex-col">
            {loading ? <Loading /> : null}
            <div className={"flex flex-row gap-2 mb-2 items-center"}>
                <span className={"font-bold text-zinc-800"}>⌘</span>
                <span className={"text-sm text-zinc-500"}>미니게임 관리</span>
                <span className={"text-sm text-blue-500"}>{"-"}</span>
                <span className={"text-sm text-zinc-500"}>동행파워볼</span>
                <span className={"text-sm text-blue-500"}>{"-"}</span>
                <span className={"text-sm font-bold"}>레벨별 배팅 설정</span>
            </div>
            <div className="flex flex-row p-2 gap-4 items-center justify-start bg-white mt-1">
                <div className={"flex flex-row gap-2 items-center"}>
                    <label className={"text-sm"}>회원레벨</label>
                    <select className={"text-sm border rounded px-3 py-1"}
                            name={"userLevel"}
                            value={searchForm.userLevel}
                            onChange={handleWhere}>
                        <option key={"1"} value={"1"}>1</option>
                        <option key={"2"} value={"2"}>2</option>
                        <option key={"3"} value={"3"}>3</option>
                        <option key={"4"} value={"4"}>4</option>
                        <option key={"5"} value={"5"}>5</option>
                        <option key={"6"} value={"6"}>6</option>
                    </select>
                </div>
            </div>
            <div className="mt-2 overflow-x-auto">
                <table className="min-w-full border bg-white">
                    <thead>
                        <tr className="bg-blue-50 rounded-t">
                            <th className="text-sm font-bold text-center py-2 px-2 w-[70px]">회원레벨</th>
                            <th className="text-sm font-bold text-left py-2 px-2 w-[180px]">베팅종류</th>
                            <th className="text-sm font-bold text-center py-2 px-2">최대베팅횟수</th>
                            <th className="text-sm font-bold text-center py-2 px-2">최소베팅금액</th>
                            <th className="text-sm font-bold text-center py-2 px-2">최대베팅금액</th>
                            <th className="text-sm font-bold text-center py-2 px-2">전체베팅금액</th>
                            <th className="text-sm font-bold text-center py-2 px-2">최대당첨금액</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataList.map((item, idx) => (
                            <tr key={idx} className="border-b">
                                <td className="text-sm text-center py-2 px-2">{item.userLevel}</td>
                                <td className="text-sm text-left py-2 px-2">{item.holeTypeNm}</td>
                                <td className="py-2 px-2">
                                    <input
                                        type="text"
                                        className="w-full p-1 text-sm border rounded text-center"
                                        value={item.maxBettingCount ? item.maxBettingCount.toLocaleString() : '0'}
                                        onChange={e => {
                                            const value = e.target.value.replace(/,/g, '');
                                            const newList = [...dataList];
                                            newList[idx].maxBettingCount = value === '' ? 0 : Number(value);
                                            setDataList(newList);
                                        }}
                                    />
                                </td>
                                <td className="py-2 px-2">
                                    <input
                                        type="text"
                                        className="w-full p-1 text-sm border rounded text-center"
                                        value={item.minBettingAmount ? item.minBettingAmount.toLocaleString() : '0'}
                                        onChange={e => {
                                            const value = e.target.value.replace(/,/g, '');
                                            const newList = [...dataList];
                                            newList[idx].minBettingAmount = value === '' ? 0 : Number(value);
                                            setDataList(newList);
                                        }}
                                    />
                                </td>
                                <td className="py-2 px-2">
                                    <input
                                        type="text"
                                        className="w-full p-1 text-sm border rounded text-center"
                                        value={item.maxBettingAmount ? item.maxBettingAmount.toLocaleString() : '0'}
                                        onChange={e => {
                                            const value = e.target.value.replace(/,/g, '');
                                            const newList = [...dataList];
                                            newList[idx].maxBettingAmount = value === '' ? 0 : Number(value);
                                            setDataList(newList);
                                        }}
                                    />
                                </td>
                                <td className="py-2 px-2">
                                    <input
                                        type="text"
                                        className="w-full p-1 text-sm border rounded text-center"
                                        value={item.totalBettingAmount ? item.totalBettingAmount.toLocaleString() : '0'}
                                        onChange={e => {
                                            const value = e.target.value.replace(/,/g, '');
                                            const newList = [...dataList];
                                            newList[idx].totalBettingAmount = value === '' ? 0 : Number(value);
                                            setDataList(newList);
                                        }}
                                    />
                                </td>
                                <td className="py-2 px-2">
                                    <input
                                        type="text"
                                        className="w-full p-1 text-sm border rounded text-center"
                                        value={item.totalWinningAmount ? item.totalWinningAmount.toLocaleString() : '0'}
                                        onChange={e => {
                                            const value = e.target.value.replace(/,/g, '');
                                            const newList = [...dataList];
                                            newList[idx].totalWinningAmount = value === '' ? 0 : Number(value);
                                            setDataList(newList);
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button className="rounded bg-zinc-800 text-white px-3 py-1 mt-2 text-sm" onClick={save}>저장</button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return {
        account, store
    }
}

export default connect(mapStateToProps, null)(DhPowerBallLevelSetting);